import React from "react";
import QuestionComment from "./QuestionComment";
import EditorialAnswer from "./EditorialAnswer";
import { useQuestionContext } from "../../shared/context/QuestionContext";
import { useTranslation } from "react-i18next";
import "./questions.css";

export default function QuestionCommentSection({ answers = [], onChange }) {
  const { t } = useTranslation();
  const { deleteAnswer, editeAnswer } = useQuestionContext();

  async function deleteMyanswer(data) {
    await deleteAnswer(data);
    onChange();
  }
  async function editeMyanswer(data) {
    await editeAnswer(data);
    onChange();
  }

  return (
    <section className="avc-answers">
      <h2 className="avc-answers__title">
        {t("Answers")}
        <span className="avc-answers__count">{answers.length}</span>
      </h2>
      {answers.length > 0 ? (
        <ul className="avc-answers__list">
          {answers.map((answer) =>
            // An editorial answer never shows a lawyer's identity.
            answer.editorial ? (
              <li key={answer._id}>
                <EditorialAnswer answer={answer} lang={localStorage.getItem("lang")} />
              </li>
            ) : (
            <QuestionComment
              key={answer._id}
              edite={editeMyanswer}
              delete={deleteMyanswer}
              answer={answer}
            />
            )
          )}
        </ul>
      ) : (
        <div className="avc-answers__empty">
          <i className="far fa-hourglass" aria-hidden="true"></i>
          <div>
            <strong>{t("qa_no_answers")}</strong>
            <p>{t("qa_no_answers_text")}</p>
          </div>
        </div>
      )}
    </section>
  );
}
